import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SurveyForm } from '../../../../components/common/survey/form/SurveyForm';
import { SurveyInputHeader } from '../../../../components/common/survey/inputs/SurveyInputHeader';
import { SurveyOverviewNavigationItem } from '../../../../components/common/survey/inputs/SurveyOverviewNavigationItem';
import { SurveyOverviewNavigationList } from '../../../../components/common/survey/inputs/SurveyOverviewNavigationList';
import { ownTractorSurveyConstants } from '../../../../constants/survey/ownTractorSurvey';
import { useAppDispatch, useAppSelector } from '../../../../hooks/store/useStore';
import { userOwnTractorSurveySlice } from '../../../../store/userOwnTractorSurveySlice';
import { OwnTractorSurveyPageWrapper } from '../OwnTractorSurveyPageWrapper';

export const OwnTractorSurveyRequiredInputOverviewPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const userOwnTractorSurveySelector = useAppSelector((state) => state.userOwnTractorSurvey);
  const userOwnTractorSurveyActions = userOwnTractorSurveySlice.actions;
  const inputValueDefaultText = '선택하기';
  const ownTractorSurveySteps = ownTractorSurveyConstants.steps;
  const currentStep = ownTractorSurveySteps.STEP1;
  const steps = Object.values(ownTractorSurveySteps);
  const handleOverviewItemClick = () => {
    navigate('/survey/progress/own-tractor/required-inputs', { replace: true });
  };
  const overviewList = [
    {
      label: '브랜드',
      inputValue: userOwnTractorSurveySelector.brand || inputValueDefaultText,
      isDisabledOnEdit: true,
      onClickHandler: handleOverviewItemClick,
    },
    {
      label: '모델',
      inputValue: userOwnTractorSurveySelector.model || inputValueDefaultText,
      isDisabledOnEdit: true,
      onClickHandler: handleOverviewItemClick,
    },
    {
      label: '마력',
      inputValue: userOwnTractorSurveySelector.engineOutputInPs || inputValueDefaultText,
      isDisabledOnEdit: true,
      onClickHandler: handleOverviewItemClick,
    },
    {
      label: '연식',
      inputValue: userOwnTractorSurveySelector.manufacturedYear || inputValueDefaultText,
      isDisabledOnEdit: false,
      onClickHandler: handleOverviewItemClick,
    },
    {
      label: '사용 시간',
      inputValue: userOwnTractorSurveySelector.operationTime || inputValueDefaultText,
      isDisabledOnEdit: false,
      onClickHandler: handleOverviewItemClick,
    },
  ];

  const isNextStepAllowed =
    !!userOwnTractorSurveySelector.brand &&
    !!userOwnTractorSurveySelector.model &&
    !!userOwnTractorSurveySelector.engineOutputInPs &&
    !!userOwnTractorSurveySelector.manufacturedYear &&
    !!userOwnTractorSurveySelector.operationTime;

  useEffect(() => {
    dispatch(userOwnTractorSurveyActions.changeIsOwnTractorSurveyStartedProperly(true));
  }, [dispatch, userOwnTractorSurveyActions]);

  return (
    <>
      <OwnTractorSurveyPageWrapper
        headerTitle={'보유하신 트랙터의\n정보를 알려주세요'}
        canConfirm={isNextStepAllowed}
        confirmHandler={() => {
          navigate('/survey/progress/own-tractor/market-price', { replace: true });
        }}
        steps={steps}
        currentStep={currentStep}
      >
        <SurveyForm padding={'0px 16px'}>
          <SurveyInputHeader inputTitle={'보유 트랙터 등록 필수 정보'} isRequired />
          <SurveyOverviewNavigationList>
            {overviewList.map((overviewItem) => {
              const { isApprovedTractor, ownTractorIdForEdit } = userOwnTractorSurveySelector;

              const isNewOrInvalidRegistration =
                overviewItem.inputValue !== inputValueDefaultText && !isApprovedTractor;

              const isApprovedTractorModification =
                !!ownTractorIdForEdit && !!isApprovedTractor && !overviewItem.isDisabledOnEdit;

              const isActive = isNewOrInvalidRegistration || isApprovedTractorModification;

              return <SurveyOverviewNavigationItem key={overviewItem.label} isActive={isActive} {...overviewItem} />;
            })}
          </SurveyOverviewNavigationList>
        </SurveyForm>
      </OwnTractorSurveyPageWrapper>
    </>
  );
};
